export type TPlatform = 'ios' | 'android' | 'desktop' | 'other';

export enum EPlatform {
  Desktop = 'desktop',
  Mobweb = 'mobweb',
}
